<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Liquidación de Productos</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <LiquidacionProductoModelAddComponent />
            </div>
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar Numero"
                  v-model="filter.searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filter.estado_str"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <LiquidacionProductoTableComponent :dataTabla="dataTabla" />
      </div>
      <PaginationComponent
        :currentPage="currentPage"
        :data="dataTabla"
        @pagechanged="filterData"
      />
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import LiquidacionProductoModelAddComponent from "@/components/inventario/liquidacion_producto/LiquidacionProductoModelAddComponent";
import LiquidacionProductoTableComponent from "@/components/inventario/liquidacion_producto/LiquidacionProductoTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    LiquidacionProductoTableComponent,
    LiquidacionProductoModelAddComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      dataTabla: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        proveedor: "",
        fecha: "",
      },
    };
  },
  computed: {
  },
  mounted() {
    this.filterData()
  },
  methods: {
    filterData(page) {
      DynamicService.fetch("inv", "liquidacion_producto").then((response) => {
        this.dataTabla = response.data;
        console.log(this.dataTabla)
      });
    },
    clearFilterData() {
      this.filter.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.tienda = "";
      this.filter.fecha = "";
      DynamicService.fetch("inv", "liquidacion_producto").then((response) => {
        this.dataTabla = response.data;
      });
    },
  },
};
</script>
